import {createSelector} from "reselect";
import {initialState} from "./reducer";
import {createSortedAvailableTimeWindows} from "../../utils/SortedAvailableTimeWindow";

/**
 * Direct selector to the timeSpanPlannerPage state domain
 */

const selectTimeSpanPlannerPageDomain = state =>
  state.get("timeSpanPlannerPage", initialState);

/**
 * Other specific selectors
 */
export const makeSelectActivity = () =>
  createSelector(selectTimeSpanPlannerPageDomain, substate =>
    substate.get("activity"),
  );

export const makeSelectTimeWindows = () =>
  createSelector(selectTimeSpanPlannerPageDomain, substate => {
    const timeWindows = substate.get("timeWindows").toJS();
    return createSortedAvailableTimeWindows(timeWindows);
  });

export const makeSelectTimeSlotsLoading = () =>
  createSelector(selectTimeSpanPlannerPageDomain, substate =>
    substate.get("loading"),
  );

export const makeSelectResult = () =>
  createSelector(selectTimeSpanPlannerPageDomain, substate =>
    substate.get("result"),
  );

export const makeSelectResultFailed = () =>
  createSelector(selectTimeSpanPlannerPageDomain, substate =>
    substate.get("resultFailed"),
  );

export const makeSelectResultLoading = () =>
  createSelector(selectTimeSpanPlannerPageDomain, substate =>
    substate.get("resultLoading"),
  );
export const makeSelectTimeslotDrivers = () =>
  createSelector(selectTimeSpanPlannerPageDomain, subState =>
    subState.get("drivers"),
  );

export const makeSelectTimeslotDriversLoading = () =>
  createSelector(selectTimeSpanPlannerPageDomain, subState =>
    subState.get("driversLoading"),
  );

export const makeSelectScanners = () =>
  createSelector(selectTimeSpanPlannerPageDomain, subState =>
    subState.get("scanners"),
  );

export const makeSelectScannersLoading = () =>
  createSelector(selectTimeSpanPlannerPageDomain, subState =>
    subState.get("scannersLoading"),
  );

/**
 * Default selector used by TimeSpanPlannerPage
 */

const makeSelectTimeSpanPlannerPage = () =>
  createSelector(selectTimeSpanPlannerPageDomain, substate => substate.toJS());

export default makeSelectTimeSpanPlannerPage;
export { selectTimeSpanPlannerPageDomain };
